/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Col,
  Row,
  Form,
  Input,
  DatePicker,
  Button,
} from 'antd';
import NumericInput from 'components/NumericInput';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { INTEGER_PATTERN_REPLACE } from 'utils/normalizers';

const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'migob';

const DatosDePago = ({
  selectedMetodo,
  visible,
  onCancel,
  callback,
  cancelCallback,
  secondCallback,
  isEditing,
  editedPago,
  justPay,
  bancos,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isEditing) {
      form.setFieldsValue(formatReceived(editedPago));
    }
    // eslint-disable-next-line
  }, [editedPago, selectedMetodo, visible]);

  const _onCancel = (_values) => {
    form.resetFields();
    if (onCancel) {
      onCancel(_values);
    }
    if (cancelCallback) {
      cancelCallback(_values);
    }
  };

  const onFinish = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      if (justPay) {
        secondCallback(values);
      } else {
        callback(values);
      }
      _onCancel(values);
    } catch (err) {
      onError(err);
    }
  };

  const rules = { required: [{ required: true }] };
  const showInput = [4, 18, 28, 19, 5, 3, 2, 6].includes(selectedMetodo);
  const labels = { 19: 'Cuenta de depósito' };
  const label = labels[selectedMetodo] || 'Últimos 4 digitos de la Cuenta/Tarjeta';
  return (
    <Modal
      open={visible}
      closable={false}
      footer={null}
      title={(
        <FormSubmitControls
          label={`${isEditing ? 'Editar' : 'Agregar'} Datos de Pago`}
          onFinish={onFinish}
          onCancel={() => _onCancel()}
        />
      )}
      onCancel={() => {
        onCancel();
        if (cancelCallback) {
          cancelCallback();
        }
      }}
      forceRender
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Row gutter={10}>
          {showInput && (
            <>
              <Col span={24}>
                <Form.Item
                  name="numero_de_cuenta"
                  rules={rules.required}
                  label={label}
                  autoComplete="off"
                  normalize={(val) => val.replace(INTEGER_PATTERN_REPLACE, '')}
                >
                  <Input
                    maxLength={selectedMetodo === 19 ? 18 : 4}
                    minLength={4}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="banco"
                  rules={rules.required}
                  label="Banco"
                >
                  <Select
                    dataSource={bancos}
                    labelProp="nombre"
                  />
                </Form.Item>
              </Col>
            </>
          )}

          {selectedMetodo === 3 && (
            <Col span={24}>
              <NumericInput
                name="clabe_interbancaria"
                required={ENV_NAME === 'nayarit'}
                label="Clabe Interbancaria"
                autoComplete="off"
              />
            </Col>
          )}

          {([2, 3, 4, 6, 12, 18, 19].includes(selectedMetodo)) && (
            <Col span={24}>
              <Form.Item
                name="fecha_de_autorizacion"
                rules={rules.required}
                label={selectedMetodo === 2
                  ? 'Fecha de Remisión del Cheque' : 'Fecha de Autorización'}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder=""
                />
              </Form.Item>
            </Col>
          )}

          {(showInput) && (
            <Col span={24}>
              <Form.Item
                name="numero_de_transaccion"
                required={ENV_NAME === 'nayarit'}
                label="No. de Transacción"
                autoComplete="off"
                normalize={(val) => val.replace(INTEGER_PATTERN_REPLACE, '')}
              >
                <Input />
              </Form.Item>
            </Col>
          )}
          {([3, 2].includes(selectedMetodo)) && (
            <Col span={24}>
              <Form.Item
                name="sucursal"
                rules={ENV_NAME === 'nayarit' ? rules.required : null}
                label="Sucursal"
              >
                <Input allowClear autoComplete="off" />
              </Form.Item>
            </Col>
          )}

        </Row>
        <Form.Item hidden>
          <Button htmlType="submit" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

DatosDePago.prototypes = {
  selectedMetodo: PropTypes.number.isRequired,
  visible: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
  cancelCallback: PropTypes.func.isRequired,
  setIsEditing: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  justPay: PropTypes.bool.isRequired,
  editedPago: PropTypes.shape({}).isRequired,
};

export default DatosDePago;
